import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import nftReducer from "./slices/NftSlice";
import userReducer from "./slices/userSlice";
import cartReducer from "./slices/CartSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk"; 

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cart", "user", "nft"],
};

const rootReducer = combineReducers({
  nft: nftReducer,
  user: userReducer,
  cart: cartReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export const persistor = persistStore(store);
